<div class="modal-body justify-content-center">
  <div class="cm-header-section">
    <h5 class="modal-title" id="projectInformationModalLabel">{{constants.modalTitle}}</h5>
    <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      <span class="cm-close-text">{{constants.close}}</span>
    </button>
  </div>

  <div class="si-container">
    <app-studio-inquiry-sidebar [activeStep]="0"></app-studio-inquiry-sidebar>

    <form class="si-application" [formGroup]="projectForm" (ngSubmit)="onNext()">
      <div class="si-section">
        <h2 class="si-section-title">{{constants.projectDetails}}<span class="star-red">*</span></h2>
        <h3 class="si-question">{{constants.projectTypeQuestion}}</h3>
        <div class="si-pi-radio-grid">
          <div class="common-radio-btn" *ngFor="let type of constants.projectTypes; let i = index">
            <input class="common-radio-input mb-0" type="radio" name="projectType" formControlName="projectType"
              [id]="'projectType-' + i" [value]="type" />
            <label class="common-radio-label" [for]="'projectType-' + i">{{type}}</label>
          </div>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.projectName}}<span class="star-red">*</span></h2>
        <div class="custom-floating-label si-field">
          <input type="text" class="form-control" id="projectName" formControlName="projectName"
            [placeholder]="constants.projectNamePlaceholder" maxlength="100" />
          <label for="projectName" class="form-label">{{constants.projectName}}</label>
          <span class="si-hint">{{constants.projectNameHint}}</span>
        </div>
      </div>

      <div class="si-section">
        <h2 class="si-section-title">{{constants.projectDates}}<span class="star-red">*</span></h2>

        <div class="si-pi-dates">
          <div class="custom-floating-label si-field" *ngFor="let field of constants.dateFields">
            <label [for]="field.id" class="form-label">{{field.label}}&nbsp;
              <span class="star-red" *ngIf="field.required">*</span>&nbsp;</label>
            <div class="input-group">
              <input class="form-control" [id]="field.id" [formControlName]="field.id"
                [placeholder]="getPlaceholder()" [firstDayOfWeek]="calenderFormat" ngbDatepicker
                #dp="ngbDatepicker" />
              <button class="btn btn-outline-secondary bi bi-calendar3 custom-button-datepicker" type="button"
                [attr.aria-label]="field.label" (click)="dp.toggle()"></button>
            </div>

            <div *ngIf="projectForm.get(field.id).hasError('invalidRange') && field.rangeMessage">
              <p class="text-danger si-error">{{field.rangeMessage}}</p>
            </div>

            <div *ngIf="projectForm.get(field.id).touched">
              <small class="text-danger si-error"
                *ngIf="projectForm.get(field.id).errors?.['required']">{{constants.requiredDate}}</small>
              <small class="text-danger si-error"
                *ngIf="projectForm.get(field.id).errors?.['invalidDate']">{{constants.invalidDate}}</small>
            </div>
          </div>
        </div>

        <div class="si-pi-schedule">
          <h3 class="si-question">{{constants.scheduleQuestion}}</h3>
          <textarea class="form-control si-pi-textarea" id="scheduleNotes" formControlName="scheduleNotes"
            [placeholder]="constants.schedulePlaceholder" rows="5"></textarea>
        </div>
      </div>

      <div class="si-buttons">
        <div class="si-back">
          <img src="../assets/images/blue-left-icon.svg" alt="" class="si-back-icon">
          <a class="text-link si-back-link" tabindex="0" (click)="onBack()" (keydown.enter)="onBack()"
            (keydown.space)="onBack()">{{constants.back}}</a>
        </div>
        <button type="submit" class="btn common-btn-secondary"
          [disabled]="projectForm.invalid">{{constants.next}}</button>
      </div>
    </form>
  </div>
</div>
